import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../Reveal";
import { guestSpots } from "../../mock";

const GuestCTASection = () => {
  return (
    <section className="relative overflow-hidden bg-foreground text-background" data-testid="guest-cta-section">
      <div className="container-x py-24 lg:py-32">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-8">
            <Reveal>
              <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-primary">Travelling artists</p>
            </Reveal>
            <Reveal delay={80}>
              <h2 className="display mt-5 text-[clamp(3rem,7vw,7rem)] uppercase leading-[0.86] tracking-wide">
                {guestSpots.subtitle}
              </h2>
            </Reveal>
            <Reveal delay={160}>
              <p className="mt-6 max-w-xl text-base leading-relaxed text-background/70 md:text-lg">{guestSpots.intro}</p>
            </Reveal>
          </div>
          <Reveal delay={200} className="lg:col-span-4 lg:justify-self-end">
            <Link
              to="/guest-spots"
              className="group inline-flex items-center gap-5"
              data-testid="guest-cta-link"
            >
              <span className="display text-3xl uppercase tracking-wide transition-colors group-hover:text-primary md:text-4xl">
                Guest Spots
              </span>
              <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary text-primary-foreground transition-transform duration-500 group-hover:rotate-45 md:h-20 md:w-20">
                <ArrowUpRight className="h-7 w-7" />
              </span>
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default GuestCTASection;
